// CONSTANTS FOR ACTION TYPES

export const GET_MOVIES = "GET_MOVIES";
export const SORT_MOVIES = "SORT_MOVIES";
export const GET_WATCHLIST = "GET_WATCHLIST";
export const UPDATE_WATCHLIST = "UPDATE_WATCHLIST";
